import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";
import Link from "@mui/material/Link";
import steve from "../../../assets/advisory/steve.jpg";
import oluseun from "../../../assets/advisory/oluseun.jpg";
import emmanuel from "../../../assets/advisory/emmanuel.png";
import akinsete from "../../../assets/advisory/akinsete.png";
import chairman from "../../../assets/advisory/chairman.jpeg";

const data = [
  {
    imgpath: chairman,
    name: "Dr. Ayodele Aderinwale",
    title: "Board Chairman",
    profile:
      "Dr. Ayodele Aderinwale, MFR is a distinguished Nigerian international development expert, academic, statesman, and entrepreneur. He is best known as the Chairman of Justrite Limited (Nigeria’s leading indigenous supermarket chain) and the long-serving Executive Director of the Africa Leadership Forum (ALF), a prominent non-governmental organization focused on grooming the continent's next generation of leaders.",
    link: "",
  },
  {
    imgpath: steve,
    name: "Steve Okeleji",
    title: "Managing Director/CEO",
    profile:
      "Steve Okeleji is a leading Nigerian aquaculture expert, agricultural consultant, and social entrepreneur with over 30 years of experience. He is the Founder and MD/CEO of Aquatic Hub Afrique Network, an ecosystem enterprise focused on expanding blue food systems, localized fish production infrastructure, and technical skill development across West Africa.",
    link: "/advisory-council/steve-okeleji",
  },
  {
    imgpath: akinsete,
    name: "Eniola Akinsete",
    title: "Non-Executive Director",
    profile:
      "Eniola Akinsete is a Nigerian corporate executive who serves as the Chief Sustainability Officer (CSO) and Group Head of Advisory Services at the Bank of Industry (BOI) Limited, Nigeria's oldest and largest development finance institution. She is a core leader within the bank’s executive operational management team, driving institutional resilience, ESG framework deployment, and green industrial funding initiatives.",
    link: "/advisory-council/iyadunni-olubode",
  },

  {
    imgpath: oluseun,
    name: "Oluseun Onigbinde",
    title: "Non-Executive Director",
    profile:
      "Oluseun Onigbinde is a prominent Nigerian entrepreneur, open data analyst, and fiscal transparency advocate. He is best known as the co-founder and Global Director of BudgIT, a leading African civic-tech organization that demystifies public finance and government budgets to encourage citizen engagement and institutional accountability.",
    link: "/advisory-council/oluseun-onigbinde",
  },
  {
    imgpath: emmanuel,
    name: "Dr. Emmanuel Okeleji",
    title: "Non-Executive Director",
    profile:
      "Dr. Emmanuel Okeleji is a Nigerian medical doctor turned tech entrepreneur, best known as the co-founder and CEO of SeamlessHR (recently rebranded as Seamless Technologies), a leading cloud-based human resources and payroll software company serving businesses across Africa. He transitioned from clinical medicine and investment banking to build enterprise software aimed at optimizing workforce productivity across the continent.",
    link: "/",
  },
];

const Details = () => {
  return (
    <Box margin={{ xs: "30% 0%", sm: "5% 0%" }}>
      <Typography
        variant={"h3"}
        fontWeight={900}
        textAlign={"left"}
        color={"#00AEEF"}
        paddingBottom={"1%"}
      >
        <Typography
          component={"span"}
          variant={"h3"}
          color="#3E4095"
          fontWeight={900}
        >
          Our {""}
        </Typography>
        Board of Directors
      </Typography>
      <Typography
        variant={"body1"}
        fontWeight={400}
        textAlign={"left"}
        color={"#000"}
        paddingBottom={"2%"}
      >
        Our Board of Directors consist of seasoned experts in fields that are
        essential to what we do. We turn to these set of visionaries for advice
        and tutelage.
      </Typography>
      <Grid container spacing={1}>
        {data.map((list, index) => {
          const { imgpath, name, link, title, profile } = list;
          return (
            <>
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                marginTop={{ xs: "10%", sm: "3%" }}
                key={index}
              >
                <Card sx={{ maxWidth: 360, height: "100%" }}>
                  <CardActionArea href={link}>
                    <CardMedia
                      component="img"
                      height="340"
                      image={imgpath}
                      sx={{ objectFit: "cover" }}
                      alt={name}
                    />
                    <CardContent>
                      <Typography
                        gutterBottom
                        variant="h5"
                        color={"#3E4095"}
                        component="div"
                        fontWeight={700}
                        paddingBottom={"1%"}
                      >
                        {name}
                      </Typography>
                      <Typography
                        paddingBottom={"2%"}
                        variant="body2"
                        color="#00AEEF"
                        fontWeight={700}
                        data-aos={"fade-up"}
                      >
                        {title}
                      </Typography>
                      <Typography
                        paddingBottom={"5%"}
                        variant="body1"
                        color="text.secondary"
                        data-aos={"fade-up"}
                      >
                        {profile}
                      </Typography>
                      {/* <Box
                        marginLeft={{ xs: " 0%", sm: "0%" }}
                        paddingTop={"2%"}
                      >
                        <Link
                          underline="none"
                          component="a"
                          href={link}
                          textAlign={"left"}
                          color="#00AEEF"
                          fontWeight={700}
                          sx={{
                            "&:hover": {
                              color: "#3E4095",
                            },
                          }}
                        >
                          Read More &#10140;
                        </Link>
                      </Box> */}
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            </>
          );
        })}
      </Grid>
    </Box>
  );
};

export default Details;
